export const ROLE_ACCESS_RIGHT = "roleAccessRight"